import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Helpers } from '@core/utils/helpers';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PcpService {

  private root = environment.services.pcp.url;

  constructor(private httpClient: HttpClient) {
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  listPcp(query: any = {}): Observable<Params> {
    query = {
      ...{
        entityType: 'provider',
        page: 0,
        pageSize: 10,
        query: '',
        fq: 'acceptingNewPatients:true;onlyPcps:PCP',
        sorting: 'location',
      },
      ...query,
    };
    return this.httpClient.get(`${this.root}/search/providers`, { params: Helpers.prepareGetParamsFromObject(query, true) });
  }
}
